import { Divider, DividerProps } from '@mui/material';

/**
 * Divider used to separate panel/menu sections (e.g. around a `SectionSubheader`, or
 * above `Sign out`). Carries no margin of its own — every layout that uses it (the
 * `AccountMenuDrawer` content area, `AppSwitcherPanel`'s root) is a flex column with
 * `gap: theme.spacing(1)` between children, which already gives this divider an 8px top
 * and bottom gap identical to every other row. Adding a margin here on top of that gap
 * would double it, so this component intentionally stays a plain pass-through — treat it
 * as the canonical section-boundary divider and always place it inside a `gap: 1` column,
 * not a plain `<Divider />` with ad-hoc margin.
 */
export function SectionDivider(props: DividerProps) {
  return <Divider {...props} />;
}
